// @flow

export const SHOW_MODAL = 'DEMO_DATA_WARNING/SHOW_CONFIRM'
export const CONFIRM_DELETE = 'DEMO_DATA_WARNING/DELETE'
export const DELETED = 'DEMO_DATA_WARNING/DELETED'
export const ERROR = 'DEMO_DATA_WARNING/ERROR'
